import React from 'react'
import { Menu } from 'antd'
import ReactToPrint from 'react-to-print'

type Props = {
  nomalPrintRef?: any
  litePrintRef?: any
  title: string
  titleSelection?: any[]
  onSelectTitle?: (title: string) => void
}

const MenuPrints = (props: Props) => {
  const { nomalPrintRef, litePrintRef, title, titleSelection = [], onSelectTitle = () => {} } = props

  return (
    <Menu>
      {nomalPrintRef &&
        (titleSelection && titleSelection.length > 0 ? (
          <Menu.SubMenu title="สั่งพิมพ์แบบมาตรฐาน">
            {titleSelection.map((item, index) => (
              <Menu.Item key={index} onMouseDown={() => onSelectTitle(item)}>
                <ReactToPrint
                  trigger={() => {
                    return <div>{item}</div>
                  }}
                  content={() => nomalPrintRef.current}
                  documentTitle={`${title}`}
                />
              </Menu.Item>
            ))}
          </Menu.SubMenu>
        ) : (
          <Menu.Item>
            <ReactToPrint
              trigger={() => {
                return <div>สั่งพิมพ์แบบมาตรฐาน</div>
              }}
              content={() => nomalPrintRef.current}
              documentTitle={`${title}`}
            />
          </Menu.Item>
        ))}
      {litePrintRef &&
        (titleSelection && titleSelection.length > 0 ? (
          <Menu.SubMenu title="สั่งพิมพ์แบบประหยัดกระดาษ">
            {titleSelection.map((item, index) => (
              <Menu.Item key={index} onMouseDown={() => onSelectTitle(item)}>
                <ReactToPrint
                  trigger={() => {
                    return <div>{item}</div>
                  }}
                  content={() => litePrintRef.current}
                  documentTitle={`(Lite)${title}`}
                />
              </Menu.Item>
            ))}
          </Menu.SubMenu>
        ) : (
          <Menu.Item>
            <ReactToPrint
              trigger={() => {
                return <div>สั่งพิมพ์แบบประหยัดกระดาษ</div>
              }}
              content={() => litePrintRef.current}
              documentTitle={`(Lite)${title}`}
            />
          </Menu.Item>
        ))}

      {/* {litePrintRef && (
        <Menu.Item>
          <ReactToPrint
            trigger={() => {
              return <span>สั่งพิมพ์แบบประหยัดกระดาษ</span>
            }}
            content={() => litePrintRef.current}
            documentTitle={`(Lite)${title}`}
          />
        </Menu.Item>
      )} */}
    </Menu>
  )
}

export default MenuPrints
